import { useAuthStore } from '@/stores/auth'
import LiveCaller from '@/LiveCaller'
import progressBar from '@/utils/progressBar'
import BaseMiddleware from './BaseMiddleware'

export default class Subscription extends BaseMiddleware {
    handle(request, next) {
        useAuthStore().load(false)
            .then((user) => {
                progressBar.done()
                if (!user?.account?.billing?.subscribed) {
                    // Routes flagged `skipSubscription` (the billing pages) must
                    // stay reachable while unsubscribed — they're the way to
                    // subscribe. Redirecting them back to upgrade would loop
                    // through this guard forever (blank/white screen).
                    const exempt = request.router.to?.matched
                        ?.some((record) => record.meta?.skipSubscription)
                    if (exempt) {
                        return next(request)
                    }
                    return request.router.next({ name: 'settings.billing.upgrade' })
                }
                return next(request)
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    request.router.next('/signin').catch(() => {})
                    return
                }
                // Any other failure: don't leave the navigation guard hanging
                // (that also blanks the screen) — surface the error and continue.
                try {
                    LiveCaller.app.$_error('Error401')
                } catch {
                    // Error handler unavailable; fall through to release the guard.
                }
                next(request)
            })
    }
}
